import React, { FC } from "react";
import { Button, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import useNavModel from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { usePurchaseRoDetailsModel } from "./purchaseRoDetailsModel";
import { Description } from "@/components/YhBox/Description";
import { IYhFormRef } from "@/components/YhFormBox/Types";
import { useDictModel } from "../../../../base/dict/dictModel";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { usePurchaseRoModel } from "../../purchaseRoModel";
import { debounce } from "lodash";
interface ITopType {
    id: string,
    mode: "add" | "edit" | "look",
    purchasePoDetails: React.MutableRefObject<IYhFormRef | undefined>
}
export const TopButs: FC<ITopType> = ({ id, mode, purchasePoDetails }) => {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale,language } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const { setSelectedRowKeys,setDescRows,setSelectedRow } = usePurchaseRoModel()
    const { detailAddForm, detailLookForm, detailEditForm, insertDetail, editDetail, Settle, getDetailEditOne, resetAddCatch, WhConfirm, setDetailAddForm, setDetailAddList } = usePurchaseRoDetailsModel();
    const { selectedNavId, addNav, findNav, selectNav, switchNavState, replaceNav } = useNavModel();
    const { getTreeNodeName,getTreeNodeOne } = useDictModel();

    const save = async () => {
        purchasePoDetails.current?.validateFields().then(async res => {
            if (mode == "add") {
                const resData = await insertDetail(res)
                console.log(resData)
                if (resData) {
                    goBack();
                    // globalPrompt("message", { text: "新增成功", type: "success" });
                    globalPrompt("message", { text: Locale["Successfully added"], type: "success" });
                    resetAddCatch(mode);
                    setSelectedRowKeys([resData.id as string])
                    setDescRows([resData])
                    setSelectedRow(resData)
                }
                // resData === true && goBack() && globalPrompt("message", { text: "新增成功", type: "success" })
            } else if (mode == "edit") {
                let { returnCode, id } = detailEditForm
                const resData = await editDetail({ ...res, returnCode, id })
                // resData === true && goBack() && globalPrompt("message", { text: "编辑成功", type: "success" })
                globalPrompt("message", { text: Locale["Successfully edited"], type: "success" });

            }
        })
    }
    const goBack = async () => {
        replaceNav(selectedNavId, "3-2")
    }
    const onSettle = async () => {
        let { returnCode, id } = detailEditForm
        let retData = await Settle({ id, returnCode })
        retData ? message.success("结算成功") && goBack() : message.error("结算失败")
    }
    const onWhConfirm = async () => {
        let { returnCode, id } = detailEditForm
        let retData = await WhConfirm({ id, returnCode })
        retData ? message.success("出库成功") && goBack() : message.error("出库失败")
    }
    const onRefresh = async () => {
        if (mode == 'add') {
            purchasePoDetails.current?.resetFields()
            setDetailAddForm({})
            setDetailAddList([])

        } else if (mode == 'edit') {
            getDetailEditOne(id, mode)
        }
        // message.success("刷新成功")
        message.success(Locale["Successfully refreshed"])

    }

    const action = <>
        {mode != "look" && <Button
            className="mr-5"
            type="link"
            shape="round"
            // onClick={() => save()}
            onClick={debounce(() => { save() }, 900)}
        >{Locale["Save"]}</Button>}
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => goBack()}
        >{Locale["Back"]}</Button>
        {/* {mode == "edit" && <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => onSettle()}
        >结算</Button>}
        {mode == "edit" && <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => onWhConfirm()}
        >出库</Button>} */}
        {mode != "look" && <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => { onRefresh() }}
        >{Locale["Refresh"]}</Button>}
    </>

    const typeTitle = {
        "add": detailAddForm,
        "edit": detailEditForm,
        "look": detailLookForm,
    }
    const orderStatu: IDescription[] = [
        {
            label: Locale["Purchase Return Doc No."],//"采购退货单",
            value: typeTitle[mode]?.returnCode as string ?? Locale["Not yet"],
            color: DescriptionColorEnum.blue,
            status: true
        },
        {
            label: Locale["Status"],//"状态",
            // value: (typeTitle[mode]?.status && getTreeNodeName(typeTitle[mode]?.status as string)) ?? Locale["Not yet"],
            value: (typeTitle[mode]?.status && (language == "zh-CN" ? getTreeNodeOne(typeTitle[mode]?.status as string)[0].name : getTreeNodeOne(typeTitle[mode]?.status as string)[0].nameEn as string)) ?? Locale["Not yet"],
            color: DescriptionColorEnum.green,
            status: true
        }
    ]
    return (
        <YhBox title={<>
            {orderStatu.map((item, index) => <Description key={index} {...item} />)}
        </>}
            action={action}
            style={{ paddingBottom: 0, marginBottom: "15px" }}
        />
    )
}